import React from 'react';
import MainPage from 'containers/pages/MainPage';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {BrowserRouter as Router} from 'react-router-dom';
import ErrorContextProvider from 'contexts/ErrorContext';
import ErrorBoundary from 'components/ErrorBoundary';

export default function App() {
    toast.configure({
        autoClose: 3000,
        position: toast.POSITION.TOP_CENTER,
    });

    return (
        <Router>
            <ErrorContextProvider>
                <ErrorBoundary>
                    <MainPage/>
                </ErrorBoundary>
            </ErrorContextProvider>
        </Router>
    );
}
